import React, { ReactNode } from "react";
import { AuthControllerProvider } from "./context/controller";
import VendorProvider from "./context/vendor/azure/provider";

const AuthProvider: React.FC<{ children?: ReactNode }> = ({ children }) => {
	return (
		<VendorProvider>
			<AuthControllerProvider>{children}</AuthControllerProvider>
		</VendorProvider>
	);
};

export default AuthProvider;
